<script setup lang="ts">
import { ref } from 'vue';
import { TEXT } from '../../configs/text';
import { classService } from '../../services';
import Heading from '../General/Heading.vue';
import { ClassItemProps } from '../../types/class';
import ClassItem from './ClassItem.vue';
import { useI18n } from 'petite-vue-i18n';

const classList = ref<ClassItemProps[]>([])

async function getTeacherClassList() {
    const data = await classService.getTeacherClassList()
    classList.value = data
}
getTeacherClassList()

const { t } = useI18n()

</script>

<template>
    <div class="p-3 md:py-8 lg:px-16 xl:px-32">
        <Heading alignment="center" size="large" color="light">{{ t(TEXT.today_schedule) }}</Heading>
        <div class="mt-5 md:mt-12 flex flex-col gap-4">
            <ClassItem v-if="classList.length" v-for="classItem in classList" v-bind="classItem" />
            <div v-else class="bg-white rounded-lg py-5 px-6 lg:py-9 lg:px-10">
                <Heading alignment="center" size="large" class="!mb-0">{{ t(TEXT.no_class_today) }}</Heading>
            </div>
        </div>
    </div>
</template>